import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { IGridContext } from "../../../product-collection-grid-view";
import { Metric } from "helpers/metrics/types";

interface IProps extends ICellRendererParams {
    getPlanHelper: (data: any, gridContext: IGridContext) => number;
    getTotalHelper: (data: any, gridContext: IGridContext) => number;
    metric?: Metric;
}

enum DiffCellClass {
    Positive = "great",
    Negative = "wayOff",
    Neutral = "",
}

class DiffCell implements ICellRendererComp {
    declare eGui: HTMLElement;
    declare eValue: HTMLElement;

    private getVarianceClass({ getPlanHelper, getTotalHelper, data, context }: IProps): DiffCellClass {
        const plan = getPlanHelper(data, context);
        const total = getTotalHelper(data, context);
        return plan > total ? DiffCellClass.Positive : plan === total ? DiffCellClass.Neutral : DiffCellClass.Negative;
    }

    private getNumericClass(value): DiffCellClass {
        const stringVal = value + "";
        if (stringVal.startsWith("-")) {
            return DiffCellClass.Negative;
        } else if (stringVal === "0") {
            return DiffCellClass.Neutral;
        } else {
            return DiffCellClass.Positive;
        }
    }

    private renderValue(params: IProps) {
        const { formatValue, value, metric } = params;

        // Clear children elements
        while (this.eValue.lastElementChild) {
            this.eValue.removeChild(this.eValue.lastElementChild);
        }

        const innerValueElement = document.createElement("span");
        if (metric) {
            innerValueElement.className = this.getNumericClass(value);
        } else if (params.getPlanHelper && params.getTotalHelper) {
            innerValueElement.className = this.getVarianceClass(params);
        }
        innerValueElement.innerText = formatValue(value);
        this.eValue.appendChild(innerValueElement);
    }

    private buildBaseElement() {
        // create the cell
        this.eGui = document.createElement("div");
        this.eGui.className = "planCell";
        this.eGui.style.width = "100%";
        this.eGui.innerHTML = '<div class="delta"></div>';

        // get references to the elements we want
        this.eValue = this.eGui.querySelector(".delta");
    }

    refresh(params: IProps): boolean {
        // set value into cell again
        this.renderValue(params);

        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.buildBaseElement();

        // set value into cell
        this.renderValue(params);
    }
}

export { DiffCell };
